import React from 'react'
import styled, { keyframes } from 'styled-components'

import Box, { BoxProps } from './box'

const FadeInBox: React.FC<BoxProps> = ({ children, ...props }) => (
  <FadeBoxWrapper {...props}>{children}</FadeBoxWrapper>
)

const fade = keyframes`
  from { opacity: 0 };
  to   { opacity: 1 };
`
const FadeBoxWrapper = styled(Box)`
  animation: ${fade} 0.3s linear;
}`

export default FadeInBox
